import type { ReactNode, ReactElement } from 'react';
import { Button } from 'react-aria-components';
import { DialogTrigger, ModalOverlay, Modal, Dialog } from '@/components/_untitled/application/modals/modal';
import type { ComponentWithClose } from '@/components/ui/ButtonHelpers';

interface ModalTriggerProps {
  content: ReactElement<ComponentWithClose>;
  children: ReactNode;
  className?: string;
  onClick?: (() => void) | undefined;
}

export const ModalTrigger = ({ content, children, className, onClick }: ModalTriggerProps) => {
  return (
    <DialogTrigger>
      <Button className={className} onPress={onClick}>
        {children}
      </Button>
      <ModalOverlay isDismissable>
        <Modal>
          <Dialog>
            {content}
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
};